import { SiteHeader } from "./SiteHeader";
import { Hero } from "./Hero";
import { Collections } from "./Collections";
import { About } from "./About";
import { Locations } from "./Locations";
import { WantList } from "./WantList";
import { Contact } from "./Contact";
import { SiteFooter } from "./SiteFooter";

export function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground paper-grain">
      <SiteHeader />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <Collections />
        <About />
        <Locations />
        <WantList />
        <Contact />
      </main>
      <SiteFooter />
    </div>
  );
}

